module.exports = __webpack_public_path__ + "img/1525128699.2e6a9960.jpg";